<div class='tandem-container'>
  <h2 class="tankyou-description">Thank you for submitting<br>your information.</h2>
  <div id="loader" class="loader-container">
    <span class="loader"></span>
  </div>
  <div id="container" class="col-md-12" #mediaAlphaHost (click)="thankYouTelemetryService.trackTandemInjectedOfferClick($event, currentLead)">
    <div [attr.id]="mediaAlphaContainerId"></div>
  </div>
</div>
